/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TSendFormAnalyticsModel = IModel<ISendFormAnalyticsRequest, TSendFormAnalyticsResponse>;

export interface ISendFormAnalyticsRequest {
  /** Номер телефона **/
  phone: string;
}

export type TSendFormAnalyticsResponse = ISendFormAnalyticsResponse200 | ISendFormAnalyticsResponse400;

export interface ISendFormAnalyticsResponse200 extends IModelResponse<ISendFormAnalyticsResponse> {
  statusCode: 200;
}

export interface ISendFormAnalyticsResponse400 extends IModelResponse<ISendFormAnalyticsResponseError> {
  statusCode: 400;
}

export interface ISendFormAnalyticsResponse {
  /** Статус выполнения запроса **/
  status: EStatus;
}

export interface ISendFormAnalyticsResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISendFormAnalyticsResponse | ISendFormAnalyticsResponseError;

export enum EStatus {
  /** Запрос обработан успешно **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISendFormAnalyticsResponse): TResponse200;
  400(response: ISendFormAnalyticsResponseError): TResponse400;
}
